import { render, staticRenderFns } from "./SupplementaryUnlicensed.vue?vue&type=template&id=9b81c4a2&scoped=true&"
import script from "./SupplementaryUnlicensed.vue?vue&type=script&lang=js&"
export * from "./SupplementaryUnlicensed.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryUnlicensed.vue?vue&type=style&index=0&id=9b81c4a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b81c4a2",
  null
  
)

component.options.__file = "SupplementaryUnlicensed.vue"
export default component.exports